import axios from 'axios';

/**
 * 资产管理模块 API
 */

// ========== 场室管理 ==========

// 场室列表
export function roomList(params) {
  return axios({
    url: '/asset/roomList',
    method: 'GET',
    params: params,
  });
}

// 保存场室
export function saveRoom(data) {
  return axios({
    url: '/asset/saveRoom',
    method: 'POST',
    data: data,
  });
}

// 删除场室
export function deleteRoom(data) {
  return axios({
    url: '/asset/deleteRoom',
    method: 'POST',
    data: data,
  });
}

// ========== 资产类别管理 ==========

// 资产类别列表
export function typeList(params) {
  return axios({
    url: '/asset/typeList',
    method: 'GET',
    params: params,
  });
}

// 保存资产类别
export function saveType(data) {
  return axios({
    url: '/asset/saveType',
    method: 'POST',
    data: data,
  });
}

// 删除资产类别
export function deleteType(data) {
  return axios({
    url: '/asset/deleteType',
    method: 'POST',
    data: data,
  });
}

// 调配类别
export function allocateType(data) {
  return axios({
    url: '/asset/allocateType',
    method: 'POST',
    data: data,
  });
}

// ========== 资产物品管理 ==========

// 资产物品列表
export function itemList(params) {
  return axios({
    url: '/asset/itemList',
    method: 'GET',
    params: params,
  });
}

// 添加资产
export function saveItem(params) {
  return axios({
    url: '/asset/saveItem',
    method: 'GET',
    params: params,
  });
}

// 调配/报废/维修/遗失/删除/调配位置
export function updateItem(data) {
  return axios({
    url: '/asset/updateItem',
    method: 'POST',
    data: data,
  });
}

// 导入资产
export function importItem(data) {
  return axios({
    url: '/asset/importItem',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: data,
  });
}

// 导出资产
export function exportItem(params) {
  return axios({
    url: '/asset/exportItem',
    method: 'GET',
    responseType: 'blob',
    params: params,
  });
}

// 生成二维码文件
export function createQrCode(params) {
  return axios({
    url: '/asset/createQrCode',
    method: 'GET',
    params: params,
    responseType: 'blob',
  });
}

// ========== 操作日志 ==========

// 操作日志列表
export function logList(params) {
  return axios({
    url: '/asset/logList',
    method: 'GET',
    params: params,
  });
}

// 导出操作日志
export function exportLog(params) {
  return axios({
    url: '/asset/exportLog',
    method: 'GET',
    responseType: 'blob',
    params: params,
  });
}

// ========== 统计 ==========

// 固定资产统计
export function statistics(params) {
  return axios({
    url: '/asset/statistics',
    method: 'GET',
    params: params,
  });
}

// 资产物品详情列表
export function statisticsDetail(params) {
  return axios({
    url: '/asset/statisticsDetail',
    method: 'GET',
    params: params,
  });
}

// 导出资产物品详情明细
export function exportItemDetails(params) {
  return axios({
    url: '/asset/exportItemDetails',
    method: 'GET',
    responseType: 'blob',
    params: params,
  });
}

// 易耗品统计
export function consumablesStatistics(params) {
  return axios({
    url: '/asset/consumablesStatistics',
    method: 'GET',
    params: params,
  });
}
